import api from "./api";

function toQuery(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    const text = String(value).trim();
    if (!text) return;
    query.set(key, text);
  });
  return query.toString();
}

export async function listSupplierTemplates(filters = {}) {
  const query = toQuery(filters);
  const res = await api.get(`/supplier-templates${query ? `?${query}` : ""}`);
  return res?.data || { items: [], pagination: { page: 1, limit: 25, total: 0, totalPages: 1 } };
}

export async function importSupplierTemplates(payload = {}) {
  const res = await api.post("/supplier-templates/import", payload);
  return res?.data || {
    requested: 0,
    importedCount: 0,
    skippedCount: 0,
    conflictCount: 0,
    createdSupplierIds: [],
    conflicts: [],
  };
}
